import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';


interface Subheader {
  id: number;
  template: string;
}

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['../patient-profile/patient-profile.component.scss', './generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {

  id = '0';
  headers:any = [];
  subheaders:any = [];
  selectedHeader:any = {id:0, title:"", description:""};
  selectedSubheader:any = {id:0, title:"", description:"", template:"", is_selected:0};
  reportFinal:any = [];
  reportMeta:any = {name:"", age:"", gender:"", reg_no:""}
  drafts:any = [];

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.loadHeaders();
  }


  loadHeaders(){
    this.dataService.getReportHeaders().subscribe( (data: any[] )=> {
      this.headers = data;
      if(this.headers.length > 0){
        this.selectHeader(this.headers[0]);
      }
      
      
    });
  }

  loadSubHeaders(header_id){
    this.dataService.getReportSubHeaders(header_id, this.id).subscribe( (data: any[] )=> {
      this.subheaders = data;
      console.log(data);
      if(this.subheaders.length > 0){
        this.selectSubheader(this.subheaders[0]);
      }
    });
  }

  selectHeader(header){
    this.selectedHeader = header;
    this.loadSubHeaders(header.id);
  }

  selectSubheader(subheader, save=0){
    
    if(save == 1 ){
      /*this.saveSection(this.selectedSubheader); */

      if(this.drafts.length > 0){
        this.drafts.forEach(element => {
          this.saveSection(element);
        });
      }

      
    } 

    if(subheader.id != this.selectedSubheader.id){
      this.selectedSubheader = subheader;
      this.loadSingleSubHeader(subheader.id);
    } else{
      if(save == 0){
        this.selectedSubheader = subheader;
        this.loadSingleSubHeader(subheader.id);
      }
    }

    
  }

  loadSingleSubHeader(id){
    this.dataService.getReportSubHeader(id, this.id).subscribe( (data:any = {status:0, id:0, title:"", description:"", template:""} )=> {
      if(data.status == 0){
        this.selectedSubheader.description = data.description;
        this.selectedSubheader.template = data.template;
        this.selectedSubheader.score_chart = data.score_chart;
      }
      
    });
  }

  

  saveSection(subheader){
    let data = {
      patient_id:this.id,
      section:subheader
    };

    this.dataService.postReportPatientData(data).subscribe( (res:any) => {
      if(res.status == 0){
        const index = this.drafts.findIndex(draft => draft.id === subheader.id);
        if (index !== -1) {
          this.drafts.splice(index, 1);
        }
        
      }
    });



  }

  toggleSectionSelection(subheader){
    
    if(subheader.is_selected == 0){
      subheader.is_selected = 1;
    } else {
      subheader.is_selected = 0;
    }

    let data = {
      patient_id:this.id,
      section:subheader
    };

    this.dataService.postReportSelection(data).subscribe( (res:any) => {
      //
    });

  }

  actionReportDone(){

    if(this.drafts.length > 0){
      this.drafts.forEach(element => {
        this.saveSection(element);
      });
    }

    alert("Report saved");
  }

  prepareDraft(){
    
    const index = this.drafts.findIndex(draft => draft.id === this.selectedSubheader.id);
    if (index === -1) {
      this.drafts.push(this.selectedSubheader);
    } else {
      this.drafts[index].template = this.selectedSubheader.template;
    }

    
  }

  generateReport(download=0){

    //fetch report data;

    this.dataService.getReportFinal(this.id).subscribe( (data:any = {report:[], reportMeta:{}}  )=> {
      this.reportFinal = data.report;
      this.reportMeta = data.reportMeta;
      this.generateReportPdf(download);
    });

    

    
  }


  generateReportPdf(download){
    //@ts-ignore
	  let doc = new jsPDF();
    let y = 10;
    let logo = "data:image/png;base64,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";
    let lineMax = 180;
    doc.addImage(logo, 'PNG', 80,y,50,14); // logo dimensions: 210x50mm
    y += 20;

    doc.setFontSize(8);
    doc.text(75, y, 'Dubai, United Arab Emirates | Kochi, Kerala, India');
    y+=5;
    doc.text(82, y, 'www.metanoa.ai | contact@metanoa.ai');
    y+=7;
    
    doc.line(0, y, 210, y);

    y+=7;

    //Report Meta;

    doc.setFontType("bold");
    doc.text(10, y, "Name: " + this.reportMeta.name);
    y+=7;
    doc.text(10, y, "Register No.: " + this.reportMeta.reg_no);
    y+=7;
    doc.text(10, y, "Age: " + this.reportMeta.age);
    y+=7;
    doc.text(10, y, "Gender: " + this.reportMeta.gender);
    y+=7;
    doc.line(0, y, 210, y);
    y+=7;

    //Report Body

    this.reportFinal.forEach(page => {

      //Print page header;
      doc.setFontType("bold");
      doc.setFontSize(10);
      doc.text(10, y, page.title.toUpperCase());
      y+=7;

      if(y >= 280){
        doc.addPage();
        y = 10;
      }

      page.sections.forEach(section => {
        
        //Print section header;
        doc.setFontType("bold");
        doc.setFontSize(8);
        doc.text(10, y, section.title.toUpperCase());
        y+=7;

        //Print section description and content;

        doc.setFontType("normal");

        if(section.description !== null && section.description.length > 0){
          doc.setFontSize(7);
          
          
          doc.text(10, y, section.description);
          
          
          y+=7;
          doc.setFontSize(8);
        } 

        /*print the content */

        const lineHeight = 7; // Set the line height

        const lines = section.content.split('\r\n'); // Split the content by newline characters

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const noLines = Math.ceil(line.length / lineMax);
          const lineArray = doc.splitTextToSize(line, lineMax);
          doc.text(10, y, lineArray);
          y += noLines * lineHeight; // Increment y by the line height multiplied by the number of lines in the current line

          //Add new page if y crosses maximum length
          if(y >= 280){
            doc.addPage();
            y = 10;
          }

        }

        

        
        if(y >= 280){
          doc.addPage();
          y = 10;
        }


      });

    });
    


    //output - download/view?
    var string = doc.output('datauristring');
    var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
    newWindow.document.write(
    '<html><head><title>'+this.reportMeta.name+' - Report </title></head><body><center>' +
    
    '</center><br>' +
    '<object width=100% height=100% type="application/pdf" data="'+string+'">' +
    '<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
    '</object></body></html>');
    newWindow.window.focus();
  }

}
